import '../styles/pages/agegate.scss'
import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet'

const MONTHS = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
]

const AgeGate = () => {
    //SCROLL TO TOP ON LOAD
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const currentDate = new Date()
    //Store the month as an index (0-11) so we can use the numeric Date
    //constructor — string date parsing like "January 5, 1990" is
    //implementation-defined and behaves differently across browsers
    const [monthIndex, setMonthIndex] = useState(0)
    const [day, setDay] = useState(1)
    const [year, setYear] = useState(currentDate.getFullYear())

    const getAge = (birthdate) => {
        const today = new Date()

        let age = today.getFullYear() - birthdate.getFullYear()
        let m = today.getMonth() - birthdate.getMonth()
        if (m < 0 || (m === 0 && today.getDate() < birthdate.getDate())) {
            age--
        }

        return age
    }

    let navigate = useNavigate()
    const goToGame = () => {
        let gamePath = `/games/${localStorage.getItem('recentGame')}`
        if (localStorage.getItem('recentGame') === '25thward-official') {
            window.location.replace('https://nisamerica.com/25thward/')
            return
        }
        navigate(gamePath, { replace: true })
    }
    const goHome = () => {
        let path = '/'
        navigate(path, { replace: true })
    }

    const handleSubmit = () => {
        //Numeric constructor: new Date(year, monthIndex, day) — guaranteed
        //consistent in every browser, no string parsing involved
        const birthdate = new Date(Number(year), Number(monthIndex), Number(day))
        const age = getAge(birthdate)

        localStorage.setItem('age', age)
        localStorage.setItem('ageTimestamp', new Date().toISOString())

        if (age > 17) {
            goToGame()
        } else {
            goHome()
        }
    }

    return (
        <div className='age-container' id='top'>
            <Helmet>
                <title>Age Gate | NIS America, Inc.</title>
            </Helmet>
            <h1 className='age-text'>Please verify your age:</h1>
            <div className='age-input'>
                <select
                    name='month'
                    value={monthIndex}
                    onChange={(e) => {
                        setMonthIndex(e.target.value)
                    }}
                >
                    {MONTHS.map((name, i) => (
                        <option key={name} value={i}>
                            {name}
                        </option>
                    ))}
                </select>
                <select
                    name='day'
                    value={day}
                    onChange={(e) => {
                        setDay(e.target.value)
                    }}
                >
                    {[...Array(31)].map((e, i) => (
                        <option key={`day-${i}`} value={i + 1}>
                            {i + 1}
                        </option>
                    ))}
                </select>
                <select
                    name='year'
                    value={year}
                    onChange={(e) => {
                        setYear(e.target.value)
                    }}
                >
                    {[...Array(100)].map((e, i) => (
                        <option key={`year-${i}`} value={currentDate.getFullYear() - i}>
                            {currentDate.getFullYear() - i}
                        </option>
                    ))}
                </select>
            </div>
            <button className='age-submit' onClick={handleSubmit}>
                Submit
            </button>
        </div>
    )
}

export default AgeGate